import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

export const sendResetCode = createAsyncThunk(
  'auth/sendResetCode',
  async ({ email, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/send-reset-code`,
        { email },
        {
          headers: {
            'Accept': 'application/json',
            'Accept-Language': lang || 'en',
            'Content-Type': 'application/json',
          },
        }
      );

      if (response?.data?.status === false) {
        return rejectWithValue(response?.data?.message || 'Failed to send code');
      }

      return response.data;
    } catch (error) {
      const responseData = error.response?.data;
      const message = responseData?.message
        || responseData?.error
        || error.message
        || 'Failed to send code';
      return rejectWithValue(message);
    }
  }
);
